import type { ReactNode } from "react";

export interface TabDef<V extends string = string> {
  value: V;
  label: ReactNode;
  count?: number;
}

export interface TabsProps<V extends string = string> {
  value: V;
  onChange?: (next: V) => void;
  tabs: TabDef<V>[];
  className?: string;
}

export function Tabs<V extends string = string>({
  value,
  onChange,
  tabs,
  className = "",
}: TabsProps<V>) {
  return (
    <div className={`flex items-end gap-6 border-b border-[var(--rule)] ${className}`}>
      {tabs.map((t) => {
        const active = t.value === value;
        return (
          <button
            key={t.value}
            type="button"
            onClick={() => onChange?.(t.value)}
            className={`relative shrink-0 whitespace-nowrap pb-2.5 text-[13px] font-medium uppercase tracking-[0.06em] transition-colors ${active ? "text-[var(--ink)]" : "text-[var(--ink-3)] hover:text-[var(--ink)]"}`}
            style={{ fontFamily: "var(--sans)" }}
          >
            <span className="flex items-baseline gap-2">
              {t.label}
              {t.count != null && (
                <span className="mono text-[11px] tabular text-[var(--ink-3)]">[{t.count}]</span>
              )}
            </span>
            {active && (
              <div className="absolute -bottom-px left-0 right-0 h-[2px] bg-[var(--ink)]" />
            )}
          </button>
        );
      })}
    </div>
  );
}
